// extracted by mini-css-extract-plugin
export default {"agenciesCreationFlyout":"AgenciesCreation_agenciesCreationFlyout__kkd9A"};